/** @format */

const BUTTONS = {
	sort: {
		label: '排序', // '排序',
		type: 'primary',
		accessControl: false,
		// icon: 'Search',
		scope: ['toolbar', 'search'],
	},
	search: {
		label: '查询', // '搜索',
		type: 'primary',
		accessControl: false,
		scope: ['toolbar', 'search'],
	},
	resetSearch: {
		label: '重置', // '重置',
		accessControl: false,
		scope: ['toolbar', 'search'],
	},
	moreSearch: {
		label: '更多', // '更多',
		// icon: 'ibps-icon-ellipsis-h',
		scope: ['toolbar', 'search'],
	},
	add: {
		label: '添加', // '添加',
		type: 'primary',
		// icon: 'ibps-icon-jiamore',
		scope: ['toolbar', 'contextmenu'],
		contextmenu: 'all',
	},
	remove: {
		label: '删除', // '删除',
		// icon: 'ibps-icon-Framemoredeleted',
		scope: ['toolbar', 'manage'],
		contextmenu: 'sub',
	},
	edit: {
		label: '编辑', // '编辑',
		// icon: 'ibps-icon-Frameedit',
		scope: ['toolbar', 'manage'],
		contextmenu: 'sub',
	},
	detail: {
		label: '明细', // '明细',
		// icon: 'ibps-icon-detail',
		scope: ['toolbar', 'manage'],
		contextmenu: 'sub',
	},
	// 'batchModify': {
	//   label: I18n.t('common.buttons.batch-modify'), // '批量修改',
	//   // icon: 'ibps-icon-check-square-o',
	//   scope: ['toolbar']
	// },
	// 'import': {
	//   label: I18n.t('common.buttons.import'), // '导入',
	//   // icon: 'ibps-icon-import',
	//   scope: ['toolbar']
	// },
	// 'export': {
	//   label: I18n.t('common.buttons.export'), //  '导出',
	//   // icon: 'ibps-icon-export',
	//   scope: ['toolbar'],
	//   dropdown: [{
	//     label: I18n.t('common.buttons.export-all'), // '导出所有',
	//     key: 'exportAll'
	//   }, {
	//     label: I18n.t('common.buttons.export-select'), // '导出选中',
	//     key: 'exportSelected'
	//   }, {
	//     label: I18n.t('common.buttons.export-current-page'), // '导出当前页',
	//     key: 'exportCurPage'
	//   }, {
	//     label: I18n.t('common.buttons.export-according-to-query-results'), // '根据查询结果导出',
	//     key: 'exportQuery'
	//   }]
	// },
	close: {
		label: '关闭', // '关闭',
		// icon: 'ibps-icon-close',
		scope: ['edit', 'detail'],
	},
	save: {
		label: '保存', // '保存',
		// icon: 'ibps-icon-save',
		accessControl: false,
		scope: ['edit'],
	},
	// 'print': {
	//   label: I18n.t('common.buttons.print'), // '打印',
	//   // icon: 'ibps-icon-print',
	//   scope: ['toolbar', 'manage', 'edit', 'detail']
	// },
	// 'custom': {
	//   label: I18n.t('common.buttons.custom'), // '自定义',
	//   // icon: 'ibps-icon-setting',
	//   scope: ['toolbar', 'manage', 'edit', 'detail', 'dialog']
	// },
	// 'confirm': {
	//   label: I18n.t('common.buttons.confirm'), // '确定',
	//   type: 'primary',
	//   // icon: 'ibps-icon-ok',
	//   scope: ['dialog']
	// },
	// 'clean': {
	//   label: I18n.t('common.buttons.clean'), // '清空',
	//   // icon: 'ibps-icon-clean',
	//   scope: ['dialog']
	// },
	// 'cleanSelected': {
	//   label: I18n.t('common.buttons.clean-select'), // '清空选择',
	//   // icon: 'ibps-icon-times-circle-o',
	//   scope: ['dialog']
	// },
	cancel: {
		label: '取消', // '取消',
		// icon: 'ibps-icon-cancel',
		accessControl: false,
		scope: ['dialog'],
	},
	// 'refresh': {
	//   label: I18n.t('common.buttons.refresh'), // '刷新',
	//   // icon: 'ibps-icon-refresh',
	//   accessControl: false,
	//   scope: ['toolbar']
	// },
	// 'expand': {
	//   label: I18n.t('common.buttons.expand'), // '展开',
	//   // icon: 'ibps-icon-expand',
	//   accessControl: false,
	//   scope: ['toolbar']
	// },
	// 'compress': {
	//   label: I18n.t('common.buttons.compress'), // '收缩',
	//   // icon: 'ibps-icon-compress',
	//   accessControl: false,
	//   scope: ['toolbar']
	// },
	// 'more': {
	//   label: I18n.t('common.buttons.more'), // '更多',
	//   // icon: 'ibps-icon-list-alt',
	//   scope: ['toolbar']
	// },
	// 'collapse': {
	//   label: I18n.t('common.buttons.collapse'), // '收缩',
	//   // icon: 'ibps-icon-angle-up',
	//   scope: ['toolbar']
	// },
	// 'expansion': {
	//   label: I18n.t('common.buttons.expansion'), // '展开',
	//   // icon: 'ibps-icon-angle-down',
	//   scope: ['toolbar']
	// },
	// 'fullscreen': {
	//   label: I18n.t('common.buttons.fullscreen'), // '全屏',
	//   // icon: 'ibps-icon-window-maximize',
	//   scope: ['toolbar']
	// },
	// 'fullscreenOn': {
	//   label: I18n.t('common.buttons.fullscreenOn'), // '小屏',
	//   // icon: 'ibps-icon-window-restore',
	//   scope: ['toolbar']
	// }
};

export { BUTTONS };

export function getButtonIcon(key) {
	if (
		key === 'add' ||
		key === 'refresh' ||
		key === 'expand' ||
		key === 'compress' ||
		key === 'search' ||
		key === 'resetSearch' ||
		key === 'edit' ||
		key === 'remove' ||
		key === 'batchRemove'
	) {
		return BUTTONS[key] ? BUTTONS[key].icon : null;
	}
	return null;
}

export function getButtonType(key) {
	if (key === 'remove' || key === 'batchRemove') {
		return BUTTONS[key] ? BUTTONS[key].type || 'danger' : 'danger';
	} else if (
		key === 'reset' ||
		key === 'edit' ||
		key === 'changePassword' ||
		key === 'actived' ||
		key === 'disable' ||
		key === 'resetSearch' ||
		key === 'setCategory' ||
		key === 'export' ||
		key === 'import' ||
		key === 'keepRelation' ||
		key === 'batchExport' ||
		key === 'batchCategory' ||
		key === 'stop' ||
		key === 'suspend' ||
		key === 'recover' ||
		key === 'assignee' ||
		key === 'detail' ||
		key === 'upLoad' ||
		key === 'refresh' ||
		key === 'category'
	) {
		return BUTTONS[key] ? BUTTONS[key].type || 'primary' : 'primary';
	} else {
		return BUTTONS[key] ? BUTTONS[key].type || 'default' : 'default';
	}
}
